import { OverlayRef } from '@angular/cdk/overlay';
import { TemplateRef, Type } from '@angular/core';
import { Subject } from 'rxjs';
import { ModalDismissEvent } from '../interfaces/modal-dismiss-event';
import { ModalOptions } from '../interfaces/modal-options';
import { ModalDismissType } from '../types/modal-dismiss-type';

export class ModalRef<R = any, T = any> {
    afterDismiss$: Subject<ModalDismissEvent<R>> = new Subject<ModalDismissEvent<R>>();

    constructor(
        public overlay: OverlayRef,
        public content: string | TemplateRef<any> | Type<any>,
        public data: T, // pass data to modal i.e. FormData
        public options: ModalOptions,
    ) {
        overlay.backdropClick().subscribe(() => this.dismiss('backdropClick', null));
    }

    close(data?: R): void {
        this.dismiss('close', data);
    }

    dismiss(type: ModalDismissType, data?: R): void {
        this.overlay.dispose();
        this.afterDismiss$.next({
            type,
            data
        });

        this.afterDismiss$.complete();
    }
}
